import { FC } from 'react';
import BackArrow from '../../assets/back_arrow.png';
import { TabletBackButtonProps } from './tabletBackButton.type';
import { getIdAttributes } from '../../utils/helper';

const TabletBackButton: FC<TabletBackButtonProps> = (props) => {
  const idPrefix = 'tablet-back-button';
  return (
    <div
      className="absolute top-16 left-10 z-20 cursor-pointer bg-white h-14 w-14 rounded-full flex items-center justify-center"
      onClick={props.onClick}
      role="button"
      aria-label="Back"
      {...getIdAttributes(idPrefix, 'container')}
    >
      <img src={BackArrow} alt="Back Arrow" className="w-4 h-4" />
    </div>
  );
};

export default TabletBackButton;
